// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nXFM","col":"styles_col__1SSYJ"};